import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {EAccountConfirmationStatus} from '@app/auth-config/models/auth-state.model';
import {selectAccountConfirmState} from '@app/auth-config/state/auth.selector';
import {StorageKeys} from '@app/core/constants/storage-keys';
import {PlatformStorage} from '@app/core/tokens/platform-storage.token';
import {Store} from '@ngrx/store';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {Subject, takeUntil, tap} from 'rxjs';
import { ExpiredTokenComponent } from '../../../signUp/components/expired-token/expired-token.component';

@Component({
    selector: 'app-account-confirmation',
    templateUrl: './account-confirmation.component.html',
    imports: [ExpiredTokenComponent],
})
export class AccountConfirmationComponent implements OnInit, OnDestroy {
  private readonly route = inject(ActivatedRoute);
  private readonly store = inject(Store);
  private readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly storage = inject(PlatformStorage);
  private readonly router = inject(Router);

  isTokenExpired = false;
  token = '' as string;
  email = '' as string;
  accountConfirmStatus = EAccountConfirmationStatus.Pending;
  eAccountConfirmationStatus = EAccountConfirmationStatus;

  private readonly unsubscribe$ = new Subject<void>();

  ngOnInit(): void {
    this.checkAccountConfirmation();
  }

  private checkAccountConfirmation(): void {
    this.route.queryParams
      .pipe(
        takeUntil(this.unsubscribe$),
        tap((params: Params) => {
          this.email = params['email'];
        })
      )
      .subscribe();

    this.store
      .select(selectAccountConfirmState)
      .pipe(
        takeUntil(this.unsubscribe$),
        tap((accountConfirmStatus: EAccountConfirmationStatus) => {
          if (accountConfirmStatus === EAccountConfirmationStatus.Confirmed) {
            this.redirectToIdentityAfterEmailValidation();
          } else {
            this.accountConfirmStatus = accountConfirmStatus;
          }
        })
      )
      .subscribe();
  }

  private redirectToIdentityAfterEmailValidation(): void {
    this.storage.removeItem(StorageKeys.accessToken);
    this.router.navigate(['/']);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
